import { BriefcaseBusiness, Share2, Store } from 'lucide-react'
import { FaFacebookF } from 'react-icons/fa'

import { LEAD_SOURCES } from './leads'

export const SOURCE_STYLES = {
  [LEAD_SOURCES.LINKEDIN]: {
    label: 'LinkedIn',
    className: 'border-sky-200 bg-sky-50 text-sky-700',
    icon: BriefcaseBusiness,
  },
  [LEAD_SOURCES.FACEBOOK]: {
    label: 'Facebook',
    className: 'border-blue-200 bg-blue-50 text-blue-700',
    icon: Share2,
  },
  [LEAD_SOURCES.OFFLINE]: {
    label: 'Offline',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    icon: Store,
  },
  facebook: {
    label: 'Facebook',
    icon: FaFacebookF,
  },
}
